import { FC } from 'react';
import { NavLink } from 'react-router-dom';
import { IConsumerChannelsLink } from '../../screens/ConsumerChannelsConfigScreen/types';
import { localeStore } from 'src/mobx/localesStore';
import { formatImagePath } from 'src/utils/formatter';
import './style.scss';

interface IProps {
  link: IConsumerChannelsLink;
}

const ConsumerChannelsConfigHeaderLink: FC<IProps> = ({ link }: IProps): JSX.Element => {
  return (
    <NavLink to={link.path} className="consumer-channel-header-link" activeClassName="consumer-channel-header-link_active">
      <div className="consumer-channel-header-link__img-wrapper">
        <img src={formatImagePath(`${link.icon}.svg`)} alt="navigation-icon" />
      </div>
      <p className="consumer-channel-header-link__title">{localeStore.t(link.title)}</p>
    </NavLink>
  );
};

export default ConsumerChannelsConfigHeaderLink;
